import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import SelectedRowDetail from "../../components/credits/creditsInstallments/selectedRowDetail";
import { ContentTitle } from "@/shared/components/layout/titleContentLayout";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { useState } from "react";
import { SelectChangeEvent } from "@mui/material";

/**

CreditsInstallmentPage

صفحه نمایش لیست اقساط اعتبار.

@component

@returns JSX.Element
*/
const DetailInstallmentPage = () => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");
  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  return (
    <BoxLayoutContent
      titleElement={
        <ContentTitle
          handleChange={handleChange}
          icon={<CalendarMonthOutlinedIcon />}
          labelInput=""
          value={value}
          setValue={setValue}
          title="خریدهای اعتباری"
        />
      }
    >
      <SelectedRowDetail />
    </BoxLayoutContent>
  );
};

export default DetailInstallmentPage;
